import { Component, OnInit, ViewChild } from '@angular/core';
import { Http } from '@angular/http';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import {Pipe} from '@angular/core';
import {ToastyService, ToastyConfig, ToastOptions, ToastData} from 'ng2-toasty';
declare var require: any
declare  const $;
import * as moment from 'moment/moment';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { AlertComponent } from './../alert/alert.component';
import { Popup } from 'ng2-opd-popup';
import { IOption } from 'ng-select';
import { CsvService } from 'angular2-json2csv';
import * as XLSX from 'xlsx';

// var countryTelData = require('country-telephone-data')
// countryTelData.allCountries // has data as array of objects 
// countryTelData.iso2Lookup // has data as a map (object) indexed by iso2 name of the country
@Component({
  selector: 'app-customermaster',
  templateUrl: './customer-master.component.html',
  styleUrls: ['./customer-master.component.scss']
})

export class CustomerMasterComponent implements OnInit {
	ToolTip="Delete is not allowed since it is used in contract registration page";
	checknum:number=0;
	format:any="Select a Country";//+971 0 00000000
	ValidDepartment_err:boolean=false;
	ValidContactName_err:boolean=false;
	// ListPhoneNumbers:any=countryTelData.allCountries;
	CountryCodes:any;
	PhoneNumberOptions:Array<IOption>=[];
	ListContactDetails=[];
	ListofAllPreventiveDetails=[];
	loading:boolean=true;
	JsonData:any[] = [];
	formName:any[] = [];
	fields:any[] = [];
	values:any[] = [];
	entryValue:any;
	public EditData:any[]=[];
	public button = 'Save';
	public EditIndex:any;
	public UpdateKey:any;
	existAddedUserId:number;
	keyValue:any;
	ListOfCustomerMaster:any[] = [];
	btnName:any='Submit';
	EditObjectId:any;
	MasterId:number;
	msgtext:string;
	startingCount:number = 0;
  	endingCount:number = 0;
  	p: number = 1;
  	customerName:any;
	phoneNumber:any;
	email:any;
	customerName_err:boolean = false;
	phoneNumber_err:boolean = false;
	email_err:boolean = false;
  	isValid:boolean = true;
  	onlyNumber_err:boolean = false;
  	rangeNumber_err:boolean = false;
  	Validemail_err:boolean = false;
  	reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{1,4})$/;
  	deleteId:number;
  	@ViewChild('delete') delete: Popup;
  	@ViewChild('add') add: Popup;
  	@ViewChild('update') update: Popup;
  	orgId:number;
	userId:number;
	phoneNumberLandline:any=+971;
	phonenumberFormat_err:boolean=false;
	phonenumberLandlineFormat_err:boolean=false;
	duplicateMessage:string = 'Customer Already Exist';
	isCustomerListLoaded:boolean = false;
	isDeleteAvailabilityLoaded:boolean = false;
	initialCountry='us'
  	constructor(private csvService: CsvService,private dialogService:DialogService,private toastyService:ToastyService,private toastyConfig: ToastyConfig,private http: Http,private router:Router,private route : ActivatedRoute){}

	ngOnInit() {
		this.loading=true;
		this.isCustomerListLoaded = false;
		this.isDeleteAvailabilityLoaded = false;
		if(this.route.params['value'].orgId === '' || this.route.params['value'].orgId === undefined || this.route.params['value'].orgId === null || this.route.params['value'].userId === undefined || this.route.params['value'].userId === '' || this.route.params['value'].userId === null){
	    	window.location.href = 'https://still.alshirawi.com/highmessaging/';
	    } else {
	      this.orgId=this.route.params['value'].orgId;
	      this.userId=this.route.params['value'].userId;
	      console.log('OrgId '+ this.orgId);
	      console.log('UserId '+ this.userId);
		}
		this.ListContactDetails.push({
			'ContactName':'',
			'Department':'',
			'ContactNumber':'',
			'Email':'',
			'serialNumber':''
		})
		// this.CheckTooltip();

		// let pusharr=[];
		//   this.ListPhoneNumbers.forEach(phoneNumbers => {
		// 	pusharr.push({"value":phoneNumbers.name,"label":phoneNumbers.dialCode});
		//   });

		//   this.PhoneNumberOptions=pusharr;

		// 	this.loading=false;
		this.getAllDetailsFromCustomerMaster();
	}

	
	getAllPreventiveMaintenanceDetails(){
		let reqPMSObj = {
			'orgId':this.orgId
		}
		return this.http.post('/api/getAllPreventiveMaintenanceDetails',reqPMSObj).subscribe(res=>{
			console.log("getAllPreventiveMaintenanceDetails",res.json());
			this.ListofAllPreventiveDetails=res.json();
			if(this.ListofAllPreventiveDetails.length>0&&this.ListOfCustomerMaster.length>0){
				//this.CheckTooltip();
			}
		},err=>{
        	console.log(err)
		})
	}

	allCustomerDetailsExport() {
		if(this.ListOfCustomerMaster.length == 0) {
			this.showInfoDialog('No Data Found');
			return false;
		}
		this.loading = true;
		let data = [];
		let hasExportRows = false;
		let rowNumber = 1;
		data.push([]);
		data.push(["Consolidated Customer Master"]);
		data.push([]);
		data.push(["S no", "Customer Name", "Customer Number", "Contact Person", "Contact Number", "Department", "Email", "Serial Number"]);
		for(let k=0;k<this.ListOfCustomerMaster.length;k++) {
			let customerDetails = this.ListOfCustomerMaster[k] || {};
			let contactDetails = Array.isArray(customerDetails.contactDetails) ? customerDetails.contactDetails : [];
			if(contactDetails.length == 0) {
				data.push([rowNumber++, customerDetails.customer_Name, customerDetails.landline_Number, '', '', '', '', '']);
				hasExportRows = true;
				continue;
			}
			for(let i=0;i<contactDetails.length;i++) {
				data.push([rowNumber++, customerDetails.customer_Name, customerDetails.landline_Number, contactDetails[i].ContactName, contactDetails[i].ContactNumber, contactDetails[i].Department, contactDetails[i].Email, contactDetails[i].serialNumber]);
				hasExportRows = true;
			}
		}
		if(hasExportRows){
			let wb: XLSX.WorkBook = XLSX.utils.book_new();
			const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(data);
			XLSX.utils.book_append_sheet(wb, ws,'Consolidated_Customer_Details');
			XLSX.writeFile(wb,'Consolidated_Customer_Details.xlsx');
		} else {
			this.showInfoDialog('No Data Found');
		}
		this.loading = false;
	}
	

	exportToExcel(values) {
		if(!values || !values.contactDetails || values.contactDetails.length == 0) {
			this.showInfoDialog('No Data Found');
			return false;
		}

		let data = [];
		data.push([]);
		data.push(["S no", "Customer Name", "Contact Number"]);
		data.push([1, values.customer_Name, values.landline_Number])
		data.push([]);
		data.push(["S No","Contact Person", "Contact Number", "Department", "Email", "Serial Number"]);
		for(let i=0;i<values.contactDetails.length;i++) {
			data.push([i+1,values.contactDetails[i].ContactName, values.contactDetails[i].ContactNumber, values.contactDetails[i].Department, values.contactDetails[i].Email, values.contactDetails[i].serialNumber]);
		}
		if(data.length>0){
			let wb: XLSX.WorkBook =XLSX.utils.book_new();
			const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(data);
			XLSX.utils.book_append_sheet(wb, ws,'Customer_Details');
			XLSX.writeFile(wb,'Customer_Details.xlsx'); 
		} else {
			this.showInfoDialog('No Data Found');
		}	
		//this.csvService.download(data, 'Customer Details');
	}

	getAllDetailsFromCustomerMaster () {
		this.loading=true;
		this.isCustomerListLoaded = false;
		this.isDeleteAvailabilityLoaded = false;
		let reqObj = {
			'orgId':this.orgId
		}
  		return this.http.post('/api/getCustomerMasterDetails', reqObj).subscribe(
     	res => {
			this.ListOfCustomerMaster = res.json();
			console.log(this.ListOfCustomerMaster)
			if(this.ListOfCustomerMaster.length>0){
				this.isCustomerListLoaded = true;
				this.loadDeleteAvailability();
			} else {
				this.isCustomerListLoaded = true;
				this.isDeleteAvailabilityLoaded = true;
				this.updateLoadingState();
				return false;
			}
		},(err) =>{
	      	this.isCustomerListLoaded = true;
	      	this.isDeleteAvailabilityLoaded = true;
	      	this.updateLoadingState();
	        if(err.status != 200){
	          this.msgtext = "Unable to load the Value";
	          this.getWarningFunction(this.msgtext);
	        }
      	})
  	}

	plus(){
		this.ListContactDetails.push({
			'ContactName':'',
			'Department':'',
			'ContactNumber':'',
			'Email':'',
			'serialNumber':''
		})
	}

	minus(index){
		this.ListContactDetails.splice(index, 1);
		if(this.ListContactDetails.length==0){
			this.ListContactDetails.push({
				'ContactName':'',
				'Department':'',
				'ContactNumber':'',
				'Email':'',
				'serialNumber':''
			})
		}
	}

  	showAlertForAddingdata(){
		this.dialogService.addDialog(AlertComponent,{title:"Customer Master",message:"The Data Added successfully"});
	}
	
	showAlertForUpdatingdata(){
		this.dialogService.addDialog(AlertComponent,{title:"Customer Master",message:"The Data Updated successfully"});
	} 

    showAlertForDeletingdata(){
		this.dialogService.addDialog(AlertComponent,{title:"Customer Master",message:"The Data Deleted sucessfully"})
	}

	showDuplicateDialog(message: any) {
		this.dialogService.addDialog(AlertComponent,{title:"Customer Master",message:message || this.duplicateMessage});
	}

	showInfoDialog(message: any) {
		this.dialogService.addDialog(AlertComponent,{title:"Customer Master",message:message});
	}

	updateLoadingState() {
		this.loading = !(this.isCustomerListLoaded && this.isDeleteAvailabilityLoaded);
	}

	normalizeCustomerName(value: any) {
		return String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
	}

	sanitizeCustomerName(value: any) {
		return String(value || '').replace(/\s+/g, ' ').trim();
	}

	findDuplicateCustomer(customerName: any, editId?: any) {
		let normalizedCustomerName = this.normalizeCustomerName(customerName);

		for(let i=0;i<this.ListOfCustomerMaster.length;i++) {
			if(
				this.normalizeCustomerName(this.ListOfCustomerMaster[i].customer_Name) == normalizedCustomerName &&
				(editId == undefined || editId == null || editId == '' || String(this.ListOfCustomerMaster[i]._id) != String(editId))
			) {
				return true;
			}
		}

		return false;
	}

	loadDeleteAvailability() {
		let customerIds = [];

		for(let i=0;i<this.ListOfCustomerMaster.length;i++) {
			this.ListOfCustomerMaster[i].status = false;
			this.ListOfCustomerMaster[i].deleteBlockedReason = '';
			customerIds.push(this.ListOfCustomerMaster[i]._id);
		}

		return this.http.post('/api/getCustomerMasterDeleteAvailability', {
			'ids':customerIds,
			'orgId':this.orgId
		}).subscribe(
			res => {
				let availabilityResponse = res.json().availability || {};

				for(let i=0;i<this.ListOfCustomerMaster.length;i++) {
					if(availabilityResponse[String(this.ListOfCustomerMaster[i]._id)] && availabilityResponse[String(this.ListOfCustomerMaster[i]._id)].canDelete === false) {
						this.ListOfCustomerMaster[i].status = true;
						this.ListOfCustomerMaster[i].deleteBlockedReason = availabilityResponse[String(this.ListOfCustomerMaster[i]._id)].reason || this.ToolTip;
					}
				}

				this.isDeleteAvailabilityLoaded = true;
				this.updateLoadingState();
			},(err) => {
				this.isDeleteAvailabilityLoaded = true;
				this.updateLoadingState();
				if(err.status != 200) {
					this.msgtext = 'Unable to validate delete availability';
					this.getWarningFunction(this.msgtext);
				}
			}
		)
	}

  	getCount(){
	    if(this.p < Math.ceil(this.values.length/10)){
	 	    this.startingCount = (this.p-1)*10;
	    	if(this.startingCount == 0){
				this.startingCount = 1;
			}
	     	this.endingCount = this.p*10;
	    } else if(this.p == Math.ceil(this.values.length/10)){
	    	let count = this.values.length%10;
	     	this.startingCount = (this.p-1)*10;
	     	this.endingCount = this.startingCount + count;
			if(this.startingCount == 0){
			this.startingCount = 1;
			this.endingCount = count;
			}
	    }
	}

    CheckTooltip(){
	
		if(this.ListOfCustomerMaster.length==0||this.ListOfCustomerMaster.length==undefined){
			this.getAllDetailsFromCustomerMaster();
		}else if(this.ListofAllPreventiveDetails.length==0||this.ListofAllPreventiveDetails.length==undefined){
			this.getAllPreventiveMaintenanceDetails ();
		}else{
			for(let j=0;j<this.ListOfCustomerMaster.length;j++){
				for(let i=0;i<this.ListofAllPreventiveDetails.length;i++){
					if(this.ListOfCustomerMaster[j]._id==this.ListofAllPreventiveDetails[i].client_Name){
						this.ListOfCustomerMaster[j].status=true;
					}
	
				}
			}
		}

this.loading=false

		
	}
	
	// Delete_CustomerMaster(index,ObjectId){
	// 	   
	// 	for(let j=0;j<this.ListOfCustomerMaster.length;j++){
	// 		if(this.ListOfCustomerMaster[j]._id==ObjectId){
	// 			for(let i=0;i<this.ListofAllPreventiveDetails.length;i++){
	// 				if(this.ListOfCustomerMaster[j]._id==this.ListofAllPreventiveDetails[i].client_Name){
	// 					// this.ClientNamefromPreventiveDetails=this.ListOfCustomerMaster[i].customer_Name;
	// 					this.ListOfCustomerMaster[j].status=true;
	// 				}
	// 			}
	// 		}
	// 	}
	// 	   
    //     for(let i=0;i<this.ListOfCustomerMaster.length;i++){
	// 		if(this.ListOfCustomerMaster[i].status==true&&this.ListOfCustomerMaster[i]._id==ObjectId){
	// 			alert("This Customer cannot be deleted as it I already used in Preventive Maintainance Form")
	// 		}else if(this.ListOfCustomerMaster[i].status==false&&this.ListOfCustomerMaster[i]._id==ObjectId){
	// 			this.Delete(index,ObjectId);
	// 		}
	// 	}
	// }
	
	getEmpty() {
	
		this.customerName = "";
		this.phoneNumber = "";
		this.email = "";
		this.EditObjectId = "";
	  	this.btnName = 'Submit';
	  	this.onlyNumber_err = false;
	  	this.customerName_err = false 
	  	this.phoneNumber_err = false;
	  	this.rangeNumber_err = false; 
	  	this.email_err = false; 
		this.Validemail_err = false;
		this.isValid=true;
		this.ValidContactName_err=false;
		this.ValidDepartment_err=false;
		  this.phoneNumberLandline="";
		  this.format="Select a Country";
		$("#landline").val('');
		$('#mobile').val('');
		this.phonenumberFormat_err=false;
		this.phonenumberLandlineFormat_err=false;
		this.ListContactDetails=[];
		this.ListContactDetails.push({
			'ContactName':'',
			'Department':'',
			'ContactNumber':'',
			'Email':'',
			'serialNumber':''
		})
	}

	phoneNumberformatvalidation(event,index){
	
		this.checknum=index;
		// var initval=/^(?:\+971|00971|971)\s(?:2|3|4|6|7|9|50|51|52|55|56)\s[0-9]{7}$/
		var initval=/^(?:\+971|00971|971)(?:55|50)[0-9]{7}$/
		var val=event.target.value;
		if(val==null||val==""||val==undefined){
			this.phonenumberFormat_err=false;
			this.isValid=true;
		}else if((initval.test(val))==false){
			this.phonenumberFormat_err=true;
			this.isValid=false;
		}else{
			this.phonenumberFormat_err=false;
			this.isValid=true;
		}
	}

	phoneNumberformatLandlinevalidation(event){
	
		var initval=/^(?:\+971|00971|0)\s(?:2|3|4|6|7|9)\s[0-9]{7}$/
	    // var val="00971551234567" ;
		var val=event.target.value;
		if(val==null||val==""||val==undefined){
			this.phonenumberLandlineFormat_err=false;
			this.isValid=true;
		}else if((initval.test(val))==false){
			this.phonenumberLandlineFormat_err=true;
			this.isValid=false;
		}else{
			this.phonenumberLandlineFormat_err=false;
			this.isValid=true;
		}
	}

	reset() {
    
		this.getEmpty();
	}

	InputcustomerName(value) {
		if(this.sanitizeCustomerName(value) == "" || this.sanitizeCustomerName(value) == undefined || this.sanitizeCustomerName(value) == null){
	      this.customerName_err = true;
	      this.isValid = false;
	    } else {
	      this.customerName_err = false;
	      this.isValid = true;
	    }
	}

	_keyPress(event: any) {
	    const pattern = /[0-9\.\ ]/;
	    let inputChar = String.fromCharCode(event.charCode);

	    if (!pattern.test(inputChar)) {
	      // invalid character, prevent input
	      event.preventDefault();
	    }
	}

	InputphoneNumber(event: any, value) {
		// if(isNaN(value))  {
		// 	this.onlyNumber_err = true;
	    //      	this.isValid = false;
		// } else {
	   //   this.onlyNumber_err = false;
	   //      if(this.onlyNumber_err == false && this.customerName_err == false && this.phoneNumber_err == false && this.rangeNumber_err == false && this.email_err == false && this.Validemail_err == false && this.customerName !== undefined && this.phoneNumber !== undefined && this.email !== undefined) {
	   //      	this.isValid = true;
	   //      }	 
	   // }

	    
		if(value.trim().length > 16 ) {
	    	this.rangeNumber_err = true;
	    	this.isValid = false;
	    	this.phoneNumber_err = false;
	    } else {
	      this.phoneNumber_err = false;
	      this.rangeNumber_err = false;
	      this.isValid = true;
	      
	    }
	}

	Inputemail(value,index) {
	
		this.checknum=index;
		if(value == "" || value == undefined || value == null){
	      
	      this.isValid = true;
	      this.Validemail_err = false;
	    } else if(this.reg.test(value) == false) {
	      this.Validemail_err = true;
	      this.isValid = false;
	      
	    }else {
	      this.isValid = true;
	      this.Validemail_err = false;
	    }
	}
// else if(this.phoneNumberLandline == "" || this.phoneNumberLandline== null || this.phoneNumberLandline == undefined) {
// 			this.isValid = false;
// 			this.spinner.hide();
// 			this.phonenumberLandlineFormat_err=false;
// 			document.body.scrollTop = 0;
//     		document.documentElement.scrollTop = 0;
// 		} else if(this.phoneNumber == "" || this.phoneNumber== null || this.phoneNumber == undefined) {
// 			this.isValid = false;
// 			this.spinner.hide();
// 			this.phonenumberFormat_err=true;
// 			document.body.scrollTop = 0;
//     		document.documentElement.scrollTop = 0;
// 		} 
	addCustomerMaster() {
	
		this.loading=false;
		this.customerName = this.sanitizeCustomerName(this.customerName);
		// if(this.ListContactDetails.length>0){
		// 	for(var i=0;i<this.ListContactDetails.length;i++) {
				 
		// 	   if(this.ListContactDetails[i].ContactNumber==""||this.ListContactDetails[i].ContactNumber==undefined||this.ListContactDetails[i].ContactNumber==null){
		// 			this.phonenumberFormat_err=true;
		// 			this.isValid = false;
		// 		}else   if(this.ListContactDetails[i].Email==""||this.ListContactDetails[i].Email==undefined||this.ListContactDetails[i].Email==null){
		// 			this.Validemail_err=true;
		// 			this.isValid = false;
		// 		}else{
		// 			this.isValid=true;
		// 		}

		// 	}
		// }
		
		if(this.customerName == "" || this.customerName== null || this.customerName == undefined) {
			this.customerName_err = true;
			this.isValid = false;
			document.body.scrollTop = 0;
    		document.documentElement.scrollTop = 0;
			this.loading=false;
		}    else {
			this.loading=false;
			let RequiredLabelArr = [];
		
			// this.getAllDetailsFromCustomerMaster();
			for(var i=0;i<this.ListContactDetails.length;i++) {
				let obj = {
					'ContactName':this.ListContactDetails[i].ContactName,
					'Department':this.ListContactDetails[i].Department,
					'ContactNumber':this.ListContactDetails[i].ContactNumber,
					'Email':this.ListContactDetails[i].Email,
					'serialNumber':this.ListContactDetails[i].serialNumber
				}
				RequiredLabelArr.push(obj);
				// this.mysqlEntryCheckListdetailArr.push([this.checkListName,this.ListCheckLists[i].issueType,this.ListCheckLists[i].item,this.ListCheckLists[i].jobDescription,0,this.orgId,this.userId,moment.utc().format('YYYY-MM-DD h:mm:ss')])
				// this.mysqlEntryUpdateListArr.push([this.checkListName,this.ListCheckLists[i].issueType,this.ListCheckLists[i].item,this.ListCheckLists[i].jobDescription,0,this.orgId,this.userId,this.userId,moment.utc().format('YYYY-MM-DD h:mm:ss'),moment.utc().format('YYYY-MM-DD h:mm:ss')])
		    }
		    if(this.EditObjectId == undefined || this.EditObjectId == null || this.EditObjectId == "") {
		    	if(this.findDuplicateCustomer(this.customerName)) {
		    		this.loading = false;
		    		this.showDuplicateDialog('Customer Already Exist');
		    		return false;
		    	}
		    	let RequiredADDObj = {
			        'masterId':this.MasterId,
			        'Customer_Name':this.customerName,
					'phonenumber_Landline':this.phoneNumberLandline,
					'ContactDetails':RequiredLabelArr,
					'orgId':this.orgId,
			        'created_By':this.userId,
			        'created_Date':moment.utc().format('YYYY:MM:DD h:mm:ss')
			    }
		    	return this.http.post('/api/addCustomerMasterDetails', RequiredADDObj).subscribe(
		        res => {
		        	this.loading=false;
		        
		        	let Response = res.json();
		            if(Response.response == 'Customer Already Exist') {
		                this.showDuplicateDialog('Customer Already Exist');
		            } else {
		            	
		            	// this.add.options = {
				        //   showButtons: false, 
				        //   color: "#4180ab",
				        //   header: "Customer Master"
				        // };
						// this.add.show(this.add.options);
						this.showAlertForAddingdata();
				        this.getEmpty();
		            	this.getAllDetailsFromCustomerMaster();
		            }
		            
		        },(err)=>{
		        	this.loading=false;
		        	if(err.status != 200) {
			            this.msgtext = "Unable to Add the Data";
			            this.getWarningFunction(this.msgtext);
		          	}
		          	console.log(err);
		        })
		    } else {
				
		    	this.loading=false;
		    	if(this.findDuplicateCustomer(this.customerName, this.EditObjectId)) {
		    		this.showDuplicateDialog('Customer Already Exist');
		    		return false;
		    	}
		    	let RequiredUpdateObj = {
			        'masterId':this.MasterId,
			        'Customer_Name':this.customerName,
					'phonenumber_Landline':this.phoneNumberLandline,
					'ContactDetails':RequiredLabelArr,
			        'EditObjectId':this.EditObjectId,
			        'orgId':this.orgId,
			        'updated_By':this.userId,
			        'updated_Date':moment.utc().format('YYYY:MM:DD h:mm:ss')
			    }
		    	return this.http.post('/api/UpdateCustomerMasterDetails', RequiredUpdateObj).subscribe(
		        res => {
					
		        	let Response = res.json();
		        	if(Response.response == 'Customer Already Exist') {
		                this.showDuplicateDialog('Customer Already Exist');
		            } else {
		            	
			        	// this.update.options = {
				        //   showButtons: false, 
				        //   color: "#4180ab",
				        //   header: "Customer Master"
				        // };
						// this.update.show(this.update.options);
						this.showAlertForUpdatingdata();
			        	this.getEmpty();
			            this.getAllDetailsFromCustomerMaster();
		            }
		        	
		        },(err)=>{
		        	this.loading=false;
		        	if(err.status != 200) {
			            this.msgtext = "Unable to Update the Data";
			            this.getWarningFunction(this.msgtext);
			        }
		          console.log(err);
		        })
		    }

	      	
		} //else end here
	}

	No() {
		this.delete.hide();
	}

	Yes() {
		this.loading=false;
		this.delete.hide();
		let deleteObj = {
	  		'data':this.deleteId,
	  		'orgId':this.orgId
	  	}
	  	return this.http.post('/api/deleteCustomerMasterDetails', deleteObj).subscribe(
	      res => {
	      	let response = res.json();
	      	if(response && response.canDelete === false) {
	      		this.showInfoDialog(response.reason || this.ToolTip);
	      		this.getAllDetailsFromCustomerMaster();
	      		return false;
	      	}
	      	
			  // alert('Delete Successfully');
			this.showAlertForDeletingdata();
	      	this.getAllDetailsFromCustomerMaster();
	      	this.getEmpty();
	      	this.delete.hide();
	    },(err)=>{
	    	this.loading=false;
	    	this.msgtext = "Unable to delete the Data";
			this.getWarningFunction(this.msgtext);
	    })
	}

	addOk() {
		this.add.hide();
	}

	updateOk() {
		this.update.hide();
	}

	// Editing(IndexCount,ObjectId) {
	// 	document.body.scrollTop = 0;
    //    	document.documentElement.scrollTop = 0;
	// 	this.EditObjectId = ObjectId;
	//   	this.btnName = 'Update';
	//   	this.customerName = this.ListOfCustomerMaster[IndexCount-1].customer_Name;
	// 	this.phoneNumber = this.ListOfCustomerMaster[IndexCount-1].phone_Number;
	// 	this.phoneNumberLandline=this.ListOfCustomerMaster[IndexCount-1].landline_Number;
	//   	this.email = this.ListOfCustomerMaster[IndexCount-1].email;
	// }

	Editing(IndexCount,ObjectId) {
		
		this.getAllDetailsFromCustomerMaster();
  		document.body.scrollTop = 0;
     	document.documentElement.scrollTop = 0;
  		this.EditObjectId = ObjectId;
    	this.btnName = 'Update';
  		this.ListContactDetails=[];
        
    	for(let i=0;i<this.ListOfCustomerMaster.length;i++){
		    if(this.ListOfCustomerMaster[i]._id==ObjectId){
			    this.customerName = this.ListOfCustomerMaster[i].customer_Name;
			//    this.phoneNumber = this.ListOfCustomerMaster[i].phone_Number;
			    this.phoneNumberLandline=this.ListOfCustomerMaster[i].landline_Number;
			//	this.email = this.ListOfCustomerMaster[i].email;
			this.ListOfCustomerMaster[i].contactDetails = [];
				 this.ListContactDetails=this.ListOfCustomerMaster[i].contactDetails
        	}
    	}
		if(this.ListContactDetails.length == 0 || this.ListContactDetails.length == undefined) {
			this.ListContactDetails.push({
				'ContactName':'',
				'Department':'',
				'ContactNumber':'',
				'Email':'',
				'serialNumber':''
			})
		}
		
 	}

	Delete(IndexCount, ObjectId) {
		document.body.scrollTop = 0;
    	document.documentElement.scrollTop = 0;
		if(this.ListOfCustomerMaster[IndexCount-1] && this.ListOfCustomerMaster[IndexCount-1].status === true) {
			this.showInfoDialog(this.ListOfCustomerMaster[IndexCount-1].deleteBlockedReason || this.ToolTip);
			return false;
		}
		this.deleteId = ObjectId;
		this.delete.options = {
          showButtons: false, 
          color: "#4180ab",
          header: "Customer Master"
        };
        this.delete.show(this.delete.options);
	  	
	}

	getWarningFunction(errMsg) {
	    var toastOptions:ToastOptions = {
	        title: "Customer Master Page",
	        msg: errMsg,
	        showClose: true,
	        timeout: 3000,
	        theme: 'bootstrap',
	        onAdd: (toast:ToastData) => {
	        },
	        onRemove: function(toast:ToastData) {
	        }
	      };
	    this.toastyService.warning(toastOptions);
	}//getWarningFunction end here


	getSuccessFunction(successMsg){
	    var toastOptions:ToastOptions = {
	      title: "Customer Master Page",
	      msg: successMsg,
	      showClose: true,
	      timeout: 3000,
	      theme: 'bootstrap',
	      onAdd: (toast:ToastData) => {
	      },
	      onRemove: function(toast:ToastData) {
	      }
	    };
	    this.toastyService.success(toastOptions);
	}//getSuccessFunction end here
}



// WEBPACK FOOTER //
// ./client/app/customer-master/customer-master.component.ts